export type StickyBarSubjectParams = {
  subjectName: string | undefined;
};

export type StickyBarCyopParams = {
  cyopSelectPoints: number;
  cyopPoints: number;
};

export function getMemoizedSubjectParams(
  currentParams: StickyBarSubjectParams | null | undefined,
  subjectName: string | undefined
): StickyBarSubjectParams {
  if (currentParams?.subjectName === subjectName && currentParams) {
    return currentParams;
  }

  return { subjectName };
}

export function getMemoizedCyopParams(
  currentParams: StickyBarCyopParams | null | undefined,
  cyopSelectPoints: number,
  cyopPoints: number
): StickyBarCyopParams {
  if (currentParams?.cyopSelectPoints === cyopSelectPoints && currentParams.cyopPoints === cyopPoints) {
    return currentParams;
  }

  return {
    cyopSelectPoints,
    cyopPoints
  };
}
